import React, { useState } from 'react';

import { AppSwitch } from '@coreui/react';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Row, Col } from 'reactstrap';
import './ModalVersao.css';

const ButtonClose = ({ handleClick }) => (
    <Button color='secondary' onClick={handleClick}>
        Fechar
    </Button>
);

const ButtonSave = ({ handleClick, textoFoto, radioSelecionado, oficial }) => (
    <Button type='submit' size='md' color='primary' onClick={(e) => handleClick(textoFoto, radioSelecionado, oficial)}>
        Criar nova versão
    </Button>
);

const InputRadioVisibilidade = ({ handleChange, value }) => (
    <FormGroup>
        <Label htmlFor='visibilidade-versao'>Visibilidade</Label>
        <div>
            <AppSwitch
                className={'visibilidade-versao switch-lg'}
                id='visibilidade-versao'
                variant={'pill'}
                color={'info'}
                label
                dataOn={'Publico'}
                dataOff={'Privado'}
                onChange={(x) => handleChange(x)}
                checked={value}
            />
        </div>
    </FormGroup>
);

const InputTextNome = ({ handleChange, value }) => (
    <FormGroup>
        <Label htmlFor='nome-versao'>Nome</Label>

        <Input
            onChange={handleChange}
            type='text'
            id='nome-versao'
            placeholder=''
            value={value}
            className='col-sm-12 form-control-sm'
            autoComplete='off'
        />
    </FormGroup>
);

const ModalVersao = ({ isOpen, onClose, onCriarVersao }) => {
    const [nome, setNome] = useState('');
    const [visibilidade, setVisibilidade] = useState(false);

    const handleInputChange = (event) => setNome(event.target.value);
    const handleRadioChange = () => setVisibilidade(!visibilidade);
    const handleCriarVersao = async () => {
        await onCriarVersao({ nome, visibilidade: visibilidade ? 0 : 1 });
        handleClose();
    };
    const handleClose = () => {
        onClose();
        clear();
    };
    const clear = () => {
        setNome('');
        setVisibilidade(false);
    };
    return (
        <Modal className='modal-dialog' isOpen={isOpen} style={{ maxWidth: '500px' }}>
            <ModalHeader>Criar verão</ModalHeader>
            <ModalBody>
                <Row>
                    <Col md='8'>
                        <InputTextNome handleChange={handleInputChange} value={nome} />
                    </Col>
                    <Col md='4'>
                        <InputRadioVisibilidade handleChange={handleRadioChange} value={visibilidade} />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <ButtonSave handleClick={handleCriarVersao} />
                <ButtonClose handleClick={handleClose} />
            </ModalFooter>
        </Modal>
    );
};

export default ModalVersao;
